import styled from 'helpers/styles';
import PropTypes from 'prop-types';
import ComponentStyles from 'styles/mixins/Component.styles';
import ToolbarWrapper from 'components/templates/Wrappers/Toolbars/ToolbarWrapper/ToolbarWrapper';

const StyledDatabaseEntitiesQueryBarWrapper = styled(ToolbarWrapper)`
  &.DatabaseEntitiesQueryBarWrapper-closed {
    > .ToolbarWrapper {
      &-toolbar {
        display: none;
      }
    }
  }
  ${ComponentStyles}
`;

StyledDatabaseEntitiesQueryBarWrapper.propTypes = {
  theme: PropTypes.object
};

export default StyledDatabaseEntitiesQueryBarWrapper;
